import React, { useState } from 'react';

// mui
import {Box, Button, IconButton, Collapse, Grid, Typography} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import ExpandMore from '@material-ui/icons/ExpandMore';
import ExpandLess from '@material-ui/icons/ExpandLess';

// components
import CustomCard from 'components/common/CustomCard';
import Link from 'components/common/Link';
import ecoCount from 'assets/img/ecocount-transparent-bg.png';
import faqHeader from 'assets/img/faq_header.png'

// lib/utils
import { helpDocs } from 'lib/docs';
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";

const useStyles = makeStyles((theme) => ({
	ecoCountImg: {
		height: '60px',
	},
	links: {
		display: 'flex',
		flexDirection: 'column',
	},
	expandButton: {
		fontSize: '16px',
		padding: '0px',
		marginRight: '5px',
	},
	expand: {
		width: 'max-content',
		marginTop: '20px',
		display: 'flex',
		alignItems: 'center',
	},
}));

export default function KioskUserGuides() {
	const classes = useStyles();

	return (
		<>
			<Grid container>
				<Grid item xs={12} style={{'textAlign': 'center'}}>
					<img src={faqHeader} style={{'width':'25%', 'minWidth':'300px'}}/>
				</Grid>
			</Grid>

			<Grid container spacing={2}>
				<Grid item xs={12}>
					<Typography variant='h1' color='primary'>EcoPay Operator Guides</Typography>
				</Grid>

				{helpDocs.operatorGuides.map(
					(doc, index) =>
						<Grid item xs={12} md={4}>
							<Card key={index} variant="outlined"  style={{'backgroundColor': 'white'}}>
                				<CardContent style={{'paddingBottom': '16px'}}>
									<Link
										variant='alternate'
										text={doc.name}
										path={`/app/help/guides/${doc.route}#operatorGuides`}
									/>
								</CardContent>
							</Card>
						</Grid>
				)}
			</Grid>
		</>
	);
}
